module.exports = __webpack_public_path__ + "img/report_7-1.6dc21245.png";